import dresscode3 from '../img/dress-code/dress-code3.png';
import dresscode4 from '../img/dress-code/dress-code4.png';

import dc from '../img/dress-code/dress-code.png';

import './DressCode.scss';
import Slider from 'react-slick';
import { useI18n } from '../i18n/i18n';

const settings = {
    dots: true,
    arrows: false,
}


export function DressCode() {
    const t = useI18n();

    return <div className="dress-code">
        <Slider {...settings}>
            <section className="half dark">
                <div className="text">
                    <h2 className="desktop">DRESS CODE</h2>
                    <h2 className="mobile">
                        {/*{'DRESS CODE'.split('').map((letter, index) => <span key={index}>{letter}</span>)}*/}
                        DRESS CODE
                    </h2>
                    <Black/>
                </div>
                <div className="img-container left gradient img-to-right-black">
                    <img src={dresscode3} alt="Black"/>
                </div>
                <div className="img-container right gradient img-to-left-black">
                    <img src={dresscode4} alt="Black"/>
                </div>
            </section>

            <div>
                <section className="half dark" id="please">
                    <div className="text">
                        <h2 className="desktop">DRESS CODE</h2>
                        <h2 className="mobile">
                            DRESS CODE
                        </h2>
                        <p style={{ color: 'var(--light)', padding: '24px', textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: t.dressCode.please }} />
                    </div>
                    <div className="img-container right gradient img-to-left-right-black">
                        <img src={dc} alt="Black"/>
                    </div>
                </section>
            </div>
        </Slider>
    </div>;
}

function Black() {
    const t = useI18n();
    return <span className="dress-code-black highlight">
        {t.dressCode.black}
    </span>;
}
